import { render, staticRenderFns } from "./CircleOfLife.vue?vue&type=template&id=4f843d08"
import script from "./CircleOfLife.vue?vue&type=script&lang=js"
export * from "./CircleOfLife.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports